const rp010 = {
  label: "Branch Open/Close Register",
  starting: true,
  url: "rp010",
  pageLabel: "Branch Open/Close Register",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Date",
      name: "",
      description: ""
    },
    {
      inputType: "date",
      dateType: "ontype",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      displayFormat: "DD/MM/YYYY",
      outputFormat: "YYYYMMDD",
      placeHolder: "",
      label: "",
      name: "fromdate",
      description: ""
    },
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Date",
      name: "",
      description: ""
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Open Branches",
      name: "openbranch",
      description: ""
    },

    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Close Branches",
      name: "closebranch",
      description: ""
    },
  ]
}

export default rp010